import script from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=474f6791&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474f6791"]])

export default __exports__